module.exports = __webpack_public_path__ + "static/media/Bicycle.47de9e3a.svg";